import type { ComponentPropsWithRef } from "react";

/** A native checkbox with the shared completion mark; focus stays on the input. */
export function ActionCheck({
  className = "",
  ...props
}: Omit<ComponentPropsWithRef<"input">, "type">) {
  return (
    <span className={`action-check ${className}`}>
      <input {...props} type="checkbox" />
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <rect
          className="action-check-open"
          x="2"
          y="2"
          width="12"
          height="12"
          rx="3.5"
        />
        <rect
          className="action-check-done"
          x="1.5"
          y="1.5"
          width="13"
          height="13"
          rx="3.5"
        />
        <path d="M4.6 8.3l2.2 2.2 4.6-4.8" />
      </svg>
    </span>
  );
}
